// Importaciones usando el nuevo modelo modular
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import logger from './logger';

// Validar que todas las variables de entorno requeridas estén definidas
const requiredEnvVars = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Mapear nombres de variables de entorno
const envVarNames = {
  apiKey: 'REACT_APP_FIREBASE_API_KEY',
  authDomain: 'REACT_APP_FIREBASE_AUTH_DOMAIN',
  projectId: 'REACT_APP_FIREBASE_PROJECT_ID',
  storageBucket: 'REACT_APP_FIREBASE_STORAGE_BUCKET',
  messagingSenderId: 'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  appId: 'REACT_APP_FIREBASE_APP_ID',
  measurementId: 'REACT_APP_FIREBASE_MEASUREMENT_ID'
};

// Verificar variables faltantes
const missingVars = Object.entries(requiredEnvVars)
  .filter(([key, value]) => !value)
  .map(([key]) => envVarNames[key]);

if (missingVars.length > 0) {
  const errorMessage = `
❌ ERROR: Faltan variables de entorno requeridas de Firebase:
${missingVars.map(v => `   - ${v}`).join('\n')}

Por favor, crea un archivo .env en la raíz del proyecto con estas variables.
Puedes usar .env.example como referencia.
  `.trim();
  
  throw new Error(errorMessage);
}

const firebaseConfig = {
  apiKey: requiredEnvVars.apiKey,
  authDomain: requiredEnvVars.authDomain,
  projectId: requiredEnvVars.projectId,
  storageBucket: requiredEnvVars.storageBucket,
  messagingSenderId: requiredEnvVars.messagingSenderId,
  appId: requiredEnvVars.appId,
  measurementId: requiredEnvVars.measurementId
};

// Inicializar Firebase solo si no ha sido inicializado
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Verificar que estamos usando el proyecto correcto (solo en desarrollo)
if (process.env.NODE_ENV === 'development') {
  logger.info('🔥 Firebase configurado para el proyecto:', firebaseConfig.projectId);
  logger.info('🔥 Auth Domain:', firebaseConfig.authDomain);
}

// Inicializar servicios
export const firestore = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Exponer en window para acceso desde consola (solo en desarrollo)
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  window.__FIREBASE_APP__ = app;
  window.__FIREBASE_FIRESTORE__ = firestore;
  window.__FIREBASE_AUTH__ = auth;
}

// Inicializar Analytics (solo en producción y si está disponible)
let analytics = null;
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.warn("Analytics no disponible:", error);
  }
}
export { analytics };

// Establecer la persistencia de sesión
setPersistence(auth, browserLocalPersistence)
    .then(() => {
        logger.debug("Persistencia configurada correctamente");
    })
    .catch((error) => {
        logger.error("Error al configurar la persistencia:", error);
    });